var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpFillArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150.001,
    height: 85.564,
    viewBox: "0 0 150.001 85.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21125",
    "data-name": "Path 21125",
    d: "M74.7,60.3c1.224-1.167,2-1.879,2.749-2.624q26.722-26.713,53.428-53.443c3.158-3.166,6.658-5.084,11.271-3.828a10.369,10.369,0,0,1,5.571,16.561,27.423,27.423,0,0,1-2.382,2.577q-30.646,30.661-61.3,61.31c-6.3,6.3-11.784,6.277-18.131-.069Q35.036,49.931,4.167,19.08C.9,15.822-.935,12.2.486,7.511A10.366,10.366,0,0,1,16.544,1.984a24.855,24.855,0,0,1,3.04,2.739Q46,31.119,72.393,57.543C73.149,58.3,73.773,59.189,74.7,60.3Z",
    transform: "translate(150.001 85.564) rotate(180)",
    fill: "#674188"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpFillArrow);
export default __webpack_public_path__ + "static/media/Up_Fill_Arrow.f71a1cd74c067b60fb8e4819687d3264.svg";
export { ForwardRef as ReactComponent };